import React  from 'react';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

// Components.
import Button from 'components/Welltory/Button';

// Styles.
import styles from './styles.module.scss';

const HeaderMenuLinks = (props) => {

  const { isAuthenticated, isDemoScrolling, theme } = props;
  const menuLinks = [];
  if (!isAuthenticated) {
    menuLinks.push(
      <a
        type="link"
        href={`/auth/signin/?destination=${window.location.pathname}`}
        key="header-menu-link-login"
        id="loginLink"
        className={cx(styles.menuLink, styles.loginLink, { [styles.isDemoScrolling]: isDemoScrolling }, { [styles.themeDark]: theme === 'ink' })}
        // onClick={onClickUserMenuLogin}
      >
        {I18n.t('Sign in')}
      </a>
    );
    menuLinks.push(
      <a
        type="link"
        href="/auth/registration/"
        key="header-menu-link-login"
        id="loginLink"
        className={cx(styles.menuLink, styles.loginLink, { [styles.isDemoScrolling]: isDemoScrolling }, { [styles.themeDark]: theme === 'ink' })}
        // onClick={onClickUserMenuLogin}
      >
        {I18n.t('Sign up')}
      </a>
    );
  }
  return menuLinks;

};

export default HeaderMenuLinks;
